<div id="container">
<div class="box1">

<!-- 見出しブロック -->
<div class="titleImage">
  <a href="http://www.asahi-net.or.jp/~cb9i-kn/" target="_self"><img [src]="logo" alt="title"></a>
</div>

  <div *ngIf="afAuth.user | async as user; else showSSOButtons">
      <!-- ユーザーのアイコン -->
        <div *ngIf="user.photoURL; else showNoIcon" class="userIcon">
          <img [src]="user.photoURL" alt="{{user.displayName}}">
        </div>
        <ng-template #showNoIcon>
          <img [src]="strNoIcon" alt="ユーザ名無し">
        </ng-template>
        <div class="titleMessage"><button (click)="logout()">ログアウトする<br />Logout</button></div>
        <div *ngIf="strLoginUserName!=''" class="titleMessage">Welcome {{strLoginUserName}} !</div>
      </div>
      
    <!-- （↓）SSOログインボタン -->
    <ng-template #showSSOButtons>
      <div *ngIf="isLoginButtons=='enabled'; else showLoginMenu" >
        <button (click)="hideButtons()">ログインボタンを隠す<br />Hide a Login Button</button>
        <p>簡単な<a href="http://www.asahi-net.or.jp/~cb9i-kn/msg/aboutme.htm" target="_blank">利用条件</a>に同意していただける方は、ここからログイン(無償)してください。<br />
          If you agree a simple <a href="http://www.asahi-net.or.jp/~cb9i-kn/msg/aboutme_e.htm" target="_blank">term of use</a>, please try to login (no charge required).</p>
        <firebase-ui
          (signInSuccessWithAuthResult)="successCallback($event)"
          (signInFailure)="errorCallback($event)">
        </firebase-ui>
        ※モバイルの場合は、Email版のみ動作可能。
        * Just in case, if you access by mobile, only 'Sign in with email' works.
        </div>
      <ng-template #showLoginMenu>
        <button (click)="showButtons()">ログインする（PC専用）<br />Login (for PC)</button>
      </ng-template>
    </ng-template>

</div>
</div>

<!--
<app-dblist [afAuthChild]="afAuth" [isLoggedIn]="isLoggedIn"></app-dblist>-->
<router-outlet></router-outlet>
<app-fileupload [afAuthChild]="afAuth" >loading...</app-fileupload>
<app-dblist [afAuthChild]="afAuth" ></app-dblist>
